// This file contains the jQuery code for displaying progress modal and triggering forms submission
// This should be refactored to use react

import {
  FileSizeError,
  FileTypeError,
  LeadingUnderscoreFilenameError,
  MaxNumberOfFilesError,
  type Restrictions,
  type RestrictionsFailedError,
  CustomValidationError,
  buildS3UploadResponseString,
  // eslint-disable-next-line boundaries/element-types, import/no-internal-modules
} from "packages/files_uploader";

declare global {
  interface Window {
    swal: any;
    ajaxOverlayConfirmation: any;
    ajaxOverlayCustom: any;
  }
}

export const onBeforeAddFiles = () => {
  const isTermsCheckboxPresent = $("#terms").length;
  const isTermsCheckboxChecked = $("#terms").is(":checked");

  if (isTermsCheckboxPresent && !isTermsCheckboxChecked) {
    window.swal({
      title: "Error!",
      text: "You have not confirmed that you own the copyright or have been granted permission to print this image. Please check that box before uploading.",
      html: true,
      type: "error",
    });

    throw new CustomValidationError();
  }
};

export const onRestrictionsFailed = (
  error: RestrictionsFailedError,
  restrictions: Restrictions
) => {
  const uploadErrors = [];

  if (error instanceof MaxNumberOfFilesError) {
    uploadErrors.push("Maximum number of files exceeded.");
  }

  if (error instanceof FileTypeError) {
    uploadErrors.push("Not an accepted File Type");
  }

  if (error instanceof FileSizeError) {
    const { maxFileSize } = restrictions;
    const maxFileSizeTextInMb =
      typeof maxFileSize === "number"
        ? `${maxFileSize / 1_000_000}mb`
        : "the maximum file size";

    uploadErrors.push(
      `<p>Filesize is greater than our <b>${maxFileSizeTextInMb} limit</b>. Please upload a smaller file.`
    );
  }

  if (error instanceof LeadingUnderscoreFilenameError) {
    uploadErrors.push(error.message);
  }

  const isTermsCheckboxPresent = $("#terms").length;
  const isTermsCheckboxChecked = $("#terms").is(":checked");

  if (isTermsCheckboxPresent && !isTermsCheckboxChecked) {
    uploadErrors.push(
      "You have not confirmed that you own the copyright or have been granted permission to print this image. Please check that box before uploading."
    );
  }

  window.swal({
    title: "Error!",
    text: uploadErrors.join("\n"),
    html: true,
    type: "error",
  });
};

export const onUploadProgress = (filename: string, progressPercent: number) => {
  $(".ajax-overlay-confirmation .initial-text").text(
    "Upload Progress by Filename"
  );

  if ($(`div[data-filename="${filename}"]`).length) {
    $(`div[data-filename="${filename}"]`).html(
      `<i class='fa-solid fa-spinner fa-spin'></i> <b>${filename}</b> uploading ${progressPercent}%`
    );
  } else {
    $(".ajax-overlay-confirmation").append(
      `<div class='uploaded-file-info' data-upload-completed='false' data-filename='${filename}'> <i class='fa-solid fa-spinner fa-spin'></i> <b>${filename}</b> uploading ${progressPercent}% </div>`
    );
  }
};

export const onUploadFailed = () => {
  const message =
    '<div class="warning"><b>Upload Failed! The Connection was interrupted.</b><br /> Please make sure you have a stable internet connection.  <br />Then, refresh the page and try again.</div>';

  window.ajaxOverlayCustom(message, 3000);
};

export const onUploadStart = () => {
  $(".ajax-overlay-confirmation")
    .addClass("uploading")
    .fadeIn()
    .html(
      '<span class="initial-text">Preparing to Start the Upload Process...</span>'
    );
};

export const onUploadSuccess = async ({
  fileName,
  uploadUrl,
  formUrl,
  $form,
  useFilename,
  uploadParamName,
  folderName,
  fileExtension,
  publicId,
  file,
}: {
  fileName: string;
  uploadUrl: string;
  formUrl: string;
  $form: JQuery<HTMLElement>;
  uploadParamName: string;
  useFilename: boolean;
  folderName: string | null;
  fileExtension: string;
  publicId: string;
  file: File;
}) => {
  $(`div[data-filename="${fileName}"]`).html(
    `<i class="fa-solid fa-spinner fa-spin"></i> <b>${fileName}</b> uploaded, now processing...`
  );
  $("body").addClass("upload-complete");

  const payload = $form.serializeArray();

  payload.push({
    name: "use_s3_upload",
    value: "true",
  });

  if (useFilename) {
    payload.push({
      name: "original_filename",
      value: fileName,
    });
  }

  if (folderName) {
    payload.push({
      name: "folder_name",
      value: folderName,
    });
  }

  const response = await buildS3UploadResponseString({
    file,
    format: fileExtension,
    publicId,
  });

  payload.push(
    {
      name: uploadParamName,
      value: uploadUrl,
    },
    {
      name: "response",
      value: response,
    }
  );

  if ($("#new_product_multi_upload_via_user_site").length) {
    $.post(formUrl, $.param(payload));
  } else if ($(".edit-job").length) {
    $.post(formUrl, $.param(payload));
  } else if ($("#new_product_via_user_site").length) {
    $.post(formUrl, $.param(payload));
  } else if ($("#apps_edit_contact_form").length) {
    $.post(formUrl, $.param(payload));
  } else if ($form.is("[data-s3-autosubmit]")) {
    // Opt-in auto-submit for forms migrated to the S3 uploader that aren't one
    // of the product/contact flows above (e.g. the tax-exemption resale
    // certificate form). Without this the form is never POSTed after S3 reaches
    // 100%, so the "now processing..." spinner hangs forever (ART-8479).
    $.post(formUrl, $.param(payload));
  }
};

export const getDataFromForm = (formId: string) => {
  const $form = $(`#${formId}`);

  const bulkCreationMax = $form.data("product-bulk-creation-max");
  const maxNumberOfFiles = bulkCreationMax ? Number(bulkCreationMax) : null;

  const uploadLimit = $form.data("limit") as string | undefined;
  const isUploadLimitSet = !!uploadLimit;

  const maxFileSize = isUploadLimitSet ? Number.parseInt(uploadLimit) : null;

  const formUrl = $form.attr("action");

  if (!formUrl) throw new Error("No form action URL found");

  return {
    maxFileSize,
    maxNumberOfFiles,
    formUrl,
    $form,
  };
};
